import {motion} from "framer-motion";
import styles from './Projects.module.css';

// Images (use any PNGs/SVGs you like, order matters)
const artifacts = [
    "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681aac5eea2fe0eff423cdbb_TeaPot.png",
    "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681aac631365f93675e6886c_Dish.png",
    "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681aac631365f93675e68864_Cup.png",
    "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681aac5e02863e74ef7ce0ec_Base.png",
];

export default function Projects() {
    return (
        <section className={styles.projectsSection}>
            {/* Featured Experience Card */}
            <motion.div
                initial={{scale: 0.94, opacity: 0}}
                whileInView={{scale: 1, opacity: 1}}
                viewport={{once: true}}
                transition={{duration: 0.85, ease: [0.23, 1, 0.32, 1]}}
                className={styles.card}
            >
                {/* Heading */}
                <motion.h2
                    initial={{opacity: 0, y: 28}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{duration: 0.66, delay: 0.15, ease: [0.23, 1, 0.32, 1]}}
                    className={styles.heading}
                >
                    Omakase<br/>Experience
                </motion.h2>

                {/* Subheading */}
                <motion.p
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{duration: 0.55, delay: 0.33}}
                    className={styles.subheading}
                >
                    Chef's curated tasting. Limited seats.<br/>
                    Reservation required.
                </motion.p>

                {/* Book a table underlined link */}
                <motion.a
                    href="/reservations"
                    initial={{opacity: 0, y: 18}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{duration: 0.53, delay: 0.38}}
                    className={styles.link}
                >
  <span className={styles.linkSpan}>
    Reservation / Order Online
    <span
        className={styles.underline}
    />
  </span>
                </motion.a>


                {/* Artifacts row (fade in, slight up stagger) */}
                <div className={styles.artifactsRow}>
                    {artifacts.map((src, i) => (
                        <motion.div
                            key={src}
                            initial={{opacity: 0, y: 40}}
                            whileInView={{opacity: 1, y: 0}}
                            transition={{duration: 0.6, delay: 0.6 + i * 0.12}}
                            className={styles.artifactContainer}
                        >
                            <img
                                src={src}
                                alt=""
                                className={styles.artifactImage}
                                draggable={false}
                            />
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </section>
    );
}
